import React, { useCallback, useEffect, useState } from 'react'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { DashCard } from '../../../components/DashCard'
import { HeaderPage } from '../../../components/HeaderPage'
import { RelatoryMenu } from '../../../components/Relatory/RealatoryMenu'
import { RelatoryFilter } from '../../../components/Relatory/RelatoryFilter'
import useApi from '../../../hooks/useApi'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../../Korbantech/components/Label'
import { AdminLayout } from '../../../layout/AdminLayout'
import { Osc } from '../../../types/Osc'
import fileDownload from "js-file-download";

export const Relatory = () => {

    const api = useApi();

    const [metrics, setMetrics] = useState<{ total_diagnosis: number, total_newosc: number, total_ebook: number, total_hints: number }>({ total_diagnosis: 0, total_newosc: 0, total_ebook: 0, total_hints: 0 })
    const [load, setLoad] = useState<boolean>(false)
    const [osc, setOsc] = useState<Osc[]>([])

    const loadData = useCallback(async () => {
        setLoad(true)
        api.get("admin/metrics/geral").then(res => {
            setMetrics(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api])

    const loadOsc = useCallback(async () => {
        setLoad(true)
        api.get("admin/metrics/list-geral").then(res => {
            setOsc(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api])

    const alterAvg = useCallback((number?: number): string => {
        let avg = 0;
        if (number)
            avg = Math.round(number)
        return "" + avg
    }, [])

    useEffect(() => {
        loadData()
        loadOsc()
    }, [loadData, loadOsc])

    const loadPDF = useCallback(() => {
        setLoad(true)
        api.get("admin/metrics/pdf-geral").then(res => {
            fileDownload( res.data, 'invoices.csv' )
        }).catch(console.log)
        setLoad(false)
    }, [api])

    return (
        <AdminLayout>
            <HeaderPage name="Relatório" button={<div className='flex items-end gap-x-3'>
                <button className='h-9 bg-white border-2 flex items-center border-gray-300 py-1 px-3' onClick={loadPDF}>
                    <AiOutlineFilePdf className='mr-1' /> Exportar relatório
                </button>
                <Label>
                    Buscar
                    <div className='flex'>
                        <TextInput />
                    </div>
                </Label>
            </div>} />
            <RelatoryMenu />

            <RelatoryFilter region city score period knowledge />

            <div className='grid grid-cols-4 gap-x-5'>
                <DashCard name='Testes preenchidos' number={metrics.total_diagnosis} />
                <DashCard name='Novos cadastros' number={metrics.total_newosc} important />
                <DashCard name='E-books baixados' number={metrics.total_ebook} important />
                <DashCard name='Dicas acessadas' number={metrics.total_hints} important />
            </div>
            <div className='grid grid-cols-12 mt-3'>
                <div className='font-semibold col-span-2'>Data</div>
                <div className='font-semibold col-span-4'>Osc</div>
                <div className='font-semibold text-center col-span-2'>Testes</div>
                <div className='font-semibold text-center col-span-1'>Ebooks</div>
                <div className='font-semibold text-center col-span-1'>Dicas</div>
                <div className='font-semibold text-center col-span-2'>Nota</div>
            </div>
            {!load && osc &&
                osc.map(item => (
                    <div key={item.id} className='grid grid-cols-12 mt-1 bg-white'>
                        <div className='p-2 col-span-2'>{item.updated_at}</div>
                        <div className=' col-span-4'>{item.corporate_name}</div>
                        <div className=' col-span-2 text-center'>{item.osc_diagnoses_count}</div>
                        <div className=' col-span-1 text-center'>{item.osc_ebook_count}</div>
                        <div className=' col-span-1 text-center'>{item.osc_hint_count}</div>
                        <div className={`col-span-2 text-center text-lg
                        ${item.average ? item.average > 6 && 'text-green-600 font-bold' : ""}`}
                        >{alterAvg(item.average)}</div>
                    </div>
                ))
            }
        </AdminLayout>
    )
}
